/* eslint-disable quotes */ 

const base = {
  h: '50px',
  fontSize: '16px',
  px: '30px',
  borderRadius: '25px'
};

const focusVisibleStyles = {
  _focusVisible: {
    outline: '2px solid #0b0c0c',
    outlineOffset: '2px'
  }
};

const whiteFocusVisibleStyles = {
  _focusVisible: {
    outline: '2px solid #fff',
    outlineOffset: '2px'
  }
};

export const mleTheme = ({
  fonts: {
    heading: `'Muli', sans-serif`,
    body: `'Muli', sans-serif`
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        color: 'white',
        ...focusVisibleStyles
      },
      variants: {
        'header-btn': {
          ...whiteFocusVisibleStyles
        },
        mle: {
          ...base,
          ...whiteFocusVisibleStyles,
          bg: '#3477c7',
          _hover: {
            bg: '#fd7849',
            _disabled: {
              bg: '#3477c7'
            }
          }
        },
        mleInvert: {
          ...base,
          ...whiteFocusVisibleStyles,
          bg: '#fd7849',
          _hover: {
            bg: '#3477c7',
            _disabled: {
              bg: '#fd7849'
            }
          }
        }
      }
    }
  }
});
